import React, {useState,useEffect} from 'react'
import apiClient from '../api/apiClient'
import CreateTestGroupModal from '../components/CreateTestGroupModal'
import AddAssessorModal from '../components/AddAssessorModal'
import AddTeacherModal from '../components/AddTeacherModal'
import {useAuth} from '../context/AuthContext'

export default function TestGroupAdminPage(){
    const {user} = useAuth()
    const schoolID = user.scId

    const [testGroups,setTestGroups] = useState([]);
    const [searchTerm, setSearchTerm] = useState('')
    const [selectedTestGroup, setSelectedTestGroup] = useState(null)

    const [createTestGroupModal, setCreateTestGroupModal] = useState(false)
    const [addAssessorModal, setAddAssessorModal] = useState(false)
    const [addTeacherModal, setAddTeacherModal] = useState(false)

    async function fetchTestGroups(){
        try{
            const result = await apiClient.get('/api/testgroup/getall', {
                params: {schoolID: schoolID}
            })
            setTestGroups(result.data)
        }catch(e){
            console.log("error in fetching all test groups")
            console.log(e)
        }

    }

    useEffect(()=>{
        fetchTestGroups()
    },[createTestGroupModal])

    async function createTestGroup(formData){
        try{
            await apiClient.post('/api/testgroup/createtestgroup', formData)
            console.log("testgropu created")
            setCreateTestGroupModal(false)
        }catch(e){
            console.log("errer creating test group")
            console.log(e)
        }
    }

    async function addCensorToTestGroup(formData){
        try{
            await apiClient.post('/api/testgroup/addcensor', formData)
            console.log("censor added to skole " + schoolID)
            setAddAssessorModal(false)
        }catch(e){
            console.log("error adding assessort")
            console.log(e)
        }
    }

    async function addTeacherToTestGroup(formData){
        try{
            await apiClient.post('/api/testgroup/addteacher', formData)
            //console.log("teacher added to school " + schoolID)
            setAddTeacherModal(false)
        }catch(e){
            console.log("fejl ved at tilføje underviser til prøvegruppe")
            console.log(e)
        }
    }

    return(
        <div>
            <div className="table-card">
                <div className="table-bar">
                    <input 
                        type="text"
                        className= "search-input"
                        placeHolder="Søg..."
                        value={searchTerm}
                        onChange={(e)=>setSearchTerm(e.target.value)}
                        />
                    <button style={{
                        backgroundColor: '#003366', color: 'white', padding: '10px 20px',
                        border: 'none', borderRadius: '8px', cursor: 'pointer'}}
                        onClick={()=>setCreateTestGroupModal(true)}
                        >
                        Opret prøvegruppe
                    </button>
                </div>
                <table className="censor-table">
                    <thead>    
                        <td>Prøvegruppe ID:</td>
                        <td>Navn:</td>
                        <td>Termin:</td>
                        <td>Eksaminator:</td>
                        <td>Censor:</td>
                        <th style={{width: '5%'}}></th>
                    </thead>
                    <tbody>
                    {testGroups.map(pg=>{
                        return(
                            <tr key={pg.id}>
                                <td>{pg.id}</td><td>{pg.navn}</td><td>{pg.termin_id}</td><td>{pg.underviser_id}</td>
                                <td>{pg.censor_id}</td>
                                <td>
                                    <button onClick={() =>{
                                        setSelectedTestGroup(pg)
                                        setAddTeacherModal(true)
                                    }}>
                                        Tilføj eksaminator
                                    </button>
                                </td>
                                <td>
                                    <button onClick={() =>{
                                        setSelectedTestGroup(pg);
                                        setAddAssessorModal(true)
                                    }}>
                                    Tilføj censor</button>
                                </td>
                            </tr>
                        )                
                    })}    
                    </tbody>
                </table>
            </div>
            {createTestGroupModal &&
                <CreateTestGroupModal
                    schoolID = {schoolID}
                    onCreate ={createTestGroup}
                    onClose = {()=>setCreateTestGroupModal(false)}
                />
            }
            {addAssessorModal && (
                <AddAssessorModal 
                    schoolID = {schoolID}
                    testGroupID= {selectedTestGroup.id}
                    term_id = {selectedTestGroup.termin_id}
                    addCensor = {addCensorToTestGroup}
                    onClose ={() => setAddAssessorModal(false)}
                    />
            )}
            {addTeacherModal && (
                <AddTeacherModal
                    schoolID = {schoolID}
                    testGroupID = {selectedTestGroup.id}
                    addTeacher = {addTeacherToTestGroup}
                    onClose= {() => setAddTeacherModal(false)}
                />
            )}
        </div>
    )
}